import React from 'react';
import { getStage, getStageColor } from '../../types/pipeline';

interface StagePillProps {
  stageId: string;
  size?: 'sm' | 'md';
}

const StagePill: React.FC<StagePillProps> = ({ stageId, size = 'sm' }) => {
  const stage = getStage(stageId);
  const color = stage?.color || getStageColor(stageId);
  const label = stage?.label || stageId;

  if (!stageId) return null;

  const sizeClasses = size === 'sm' ? 'px-2 py-0.5 text-xs' : 'px-3 py-1 text-sm';

  return (
    <span
      className={`inline-flex items-center rounded-full font-medium ${sizeClasses}`}
      style={{
        backgroundColor: `${color}18`,
        color: color,
        border: `1px solid ${color}40`,
      }}
    >
      {label}
    </span>
  );
};

export default StagePill;
